import { Link, Stack, Typography } from '@mui/material';
import useLocales from '#/hooks/useLocales';
import { RHFCheckbox } from '#/components/shared/hook-form';
import HighlightedTextFormat from './highlight-format';
import { useNavigate, Link as RouterLink } from 'react-router-dom';

export default function AgreeCheckbox() {
  const { translate } = useLocales();
  const navigate = useNavigate();

  const highlightWords = translate('pensionProvision.highlightWords', {
    returnObjects: true,
  })
    .split(',')
    .map((item) => item.trim());

  return (
    <Stack
      direction="column"
      justifyContent="flex-start"
      sx={{
        width: {
          xs: '100%',
          md: '60%',
        },
      }}
    >
      <RHFCheckbox
        name="agree"
        label={
          <Typography>
            <HighlightedTextFormat
              component={RouterLink}
              context={translate('pensionProvision.confirmCheckbox')}
              targets={translate('pensionProvision.highlightWords', {
                returnObjects: true,
              })
                .split(',')
                .map((item) => item.trim())}
              onClickHandlers={{
                [highlightWords[0]]: () =>
                  window.open('/datenschutzbestimmungen', '_blank'),
                [highlightWords[1]]: () => window.open('/agb', '_blank'),
              }}
              sx={{
                fontWeight: 'bold',
              }}
            />
          </Typography>
        }
      />
      {/* <Anchor
        sx={{
          textDecoration: 'none',
        }}
        href="https://storage.gutgeregelt.ch/docs/gut_geregelt_DPA.pdf"
        target="_blank"
      > */}
      <Typography sx={{ marginLeft: '30px' }} variant="body2" component="span">
        {String(translate('pensionProvision.processingAgreement'))}
      </Typography>
      {/* </Anchor> */}
    </Stack>
  );
}
